import { Component } from '@angular/core';
import Swiper from 'swiper';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {
  constructor(){
    console.log("about");
  }

  swiper() {
    new Swiper(".mySwiper_ads", {
      slidesPerView: 3,
      spaceBetween: 20,
      freeMode: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 2,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 2,
        },
        769: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        500: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        350: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}
